import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem,
Grid, Divider, Table, TableBody, TableCell,TableHead, TableRow, TablePagination } from '@material-ui/core';
import { } from '@material-ui/icons';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Line} from 'react-chartjs-2';
import Select from 'react-select';
import creds from '../../config/firebaseConfig';
import db from '../../config/firestoreConfig';

const styles = theme => ({
    placeholder: {
        display: 'block'
    },
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
        overflowX: 'auto'
       
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    paper2: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        overflowX: 'auto'
    },
    button: {
        margin: theme.spacing.unit,
        width: 150 
      },
    table : {
        minWidth: 700
    },
    grid: {
        overflowX: 'auto'
    }
})

let id = 0;

class performance2 extends Component{
    constructor(props){
        super(props)
        this.state = { 
            groupsChecked: false,
            viewLevel: '',
            viewSubject: '',
            viewYr: '',
            viewAbility: '',
            abilities: [ 'Beginner', 'Intermediate', 'Advanced' ],
            page: 0,
            rowsPerPage: 5,
            loaded: false,
            rowRawData: []
        }
    }

    async componentDidMount(){
        var levels = []
        var subjects = []
        var years = []
        var abilities = this.state.abilities
        var students = []

        const ref = await db.collection('Level').get()
        ref.forEach( async level => { 
            levels.push(level.id)
            var subjArr = []
            var holdingArr = [] //Is this needed? - Yes
            const subjRef = await db.collection('Level').doc(level.id).collection('Subjects').get()
            subjRef.forEach( async subject => {
                subjArr.push(subject.id)
                var yearArr = []
                const yearRef = await db.collection('Level').doc(level.id).collection('Subjects').doc(subject.id).collection('Years').get()
                yearRef.forEach( async year => { 
                    yearArr.push(year.id)
                })
                holdingArr.push(yearArr)
            })
            years.push(holdingArr)
            subjects.push(subjArr)
        })
        console.log(levels, subjects, years, abilities)
        const studentsRef = await db.collection('Users').where('accountType', '==', 'Student').get()
        studentsRef.forEach(student => { 
            students.push(student.data())
        })
        console.log(students)
        this.setState({
            ...this.state,
            levels: levels,
            subjects: subjects,
            years: years,
            abilities: abilities,
            students: students,
            loaded: true,
            student: ''
        })
    }

    handleChange = name => event => { 

        if (name == 'student'){
            console.log('STUDENT')
            this.getContent(event.target.value)
        }
        if (name != 'viewLevel') {
            this.setState({
                        ...this.state,
                        [name]: event.target.value,
                        yearError: false,
                        subjectError: false, 
                        levelError: false,
                        abilityError: false,
                    })
        } else {
            this.setState({
                ...this.state,
                [name]: event.target.value,
                yearError: false,
                subjectError: false, 
                levelError: false,
                abilityError: false,
                viewSubject: '',
                viewYr: '',
                student: ''
            })
        }
        
    }

    StudentList = arr => { 
        var output = []
        arr.forEach( student => { 
            if (student.CurrentLevel == this.state.viewLevel && student.CurrentYear == this.state.viewYr){
                output.push(student)
            }
        })
        return output
    }

    getContent = async uid => { 
        var hwk = []
        var tests = []
        var myHwk = []
        var myTests = []
        var recentHwk = []
        var recentTests = []
        var lateHwk = []
        var lateTests = []
        var student = ''
        this.state.students.forEach(stu => { 
            if (stu.UID == uid){
                return student = stu
            }
        })
        // console.log(student) //debug

        const hwkRef = await db.collection('AssignedTasks').where('Test', '==', false).get()
        const testRef = await db.collection('AssignedTasks').where('Test', '==', true).get()


        //Get the hwk and tests that are relevant to this student 
        hwkRef.forEach( task => { 
            const members = task.data().AssignedTo
            members.forEach( stdnt => { 
                if (stdnt.Student == student.UID){
                    hwk.push({title: task.id, data: task.data()})
                    myHwk.push({title: task.id, data: stdnt, meta: task.data()})
                }
            })
        })

        testRef.forEach( task => { 
            const members = task.data().AssignedTo
            members.forEach( stdnt => { 
                if (stdnt.Student == student.UID){
                    tests.push({title: task.id, data: task.data()})
                    myTests.push({title: task.id, data: stdnt, meta: task.data()})
                }
            })
        })

        // console.log(hwk, tests) //debug
        hwk.sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
        myHwk.sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
        myTests.sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
        tests.sort(function (a,b){return new Date(a.data.Deadline).valueOf() - new Date(b.data.Deadline).valueOf()}) //just to be sure that it's ordered correctly
        // console.log(hwk, tests) //debug
        
        //Get the recent tasks
        myHwk.forEach( task => { 
            if (recentHwk.length < 5){
                if (task.data.CompletionDate != 'N/A') {
                    recentHwk.push(task)
                } else {
                    console.log('LATE EVAL', new Date().valueOf(), new Date(task.meta.Deadline).valueOf(), (new Date().valueOf() > new Date(task.meta.Deadline).valueOf()), task)
                    if (new Date().valueOf() > new Date(task.meta.Deadline).valueOf()){
                        lateHwk.push(task)
                    }
                }
            }
        })

        myTests.forEach( task => { 
            if (recentTests.length < 5){
                if (task.data.CompletionDate != 'N/A') {
                    recentTests.push(task)
                } else {
                    if (new Date().valueOf() > new Date(task.meta.Deadline).valueOf()){
                        lateTests.push(task)
                    }
                }
            }
        })
        // console.log(hwk, myHwk, recentHwk, lateHwk) //debug
        // console.log(tests, myTests, recentTests, lateTests) //debug

        recentTests.forEach(test => { 
            test.data.isTest = true
        })

        var allTasks = recentHwk.concat(recentTests);
        var allTests = hwk.concat(tests)
        var avgs = this.getGroupAvg(allTests, allTasks)
        
        var status = this.getStatus(recentHwk, recentTests);
        var myAvg = '-';
        var classAvg = '-';

        // switch(status) {
        //     case 0:
        //          myAvg = '-'
        //          classAvg = '-'
        //         break;
        //     case 1:
        //          myAvg = ((this.getAvgScore(recentHwk) + this.getAvgScore(recentTests))/2)
        //          classAvg = ((this.getGroupAvg(hwk, recentHwk) + this.getGroupAvg(tests, recentTests))/2)
        //         break;
        //     case 2 :
        //          myAvg = this.getAvgScore(recentTests)
        //          classAvg = this.getGroupAvg(tests, recentTests)
        //         break;
        //     case 3 :
        //          myAvg = this.getAvgScore(recentHwk)
        //          classAvg = this.getGroupAvg(hwk, recentHwk)
        //         break;
        //     default :
        //          myAvg = 'ERROR'
        //         break;
        // }

        // console.log('MAGIC', myAvg, status) //debug
        console.log('MAGIC AGAIN', classAvg, status) //debug
        console.log('MAGIC V2', student.displayName, allTasks, lateHwk, lateTests, myAvg, avgs)
        var stateRows = []
        allTasks.forEach(task => { 
            const relevantAvg = this.matchAvg(task.title, avgs)
            if (task.data.isTest){
                stateRows.push({name: student.displayName, hwk: '-', test: task.title, subject: relevantAvg.subject, lateHwk: lateHwk, lateTests: lateTests, score: task.data.Score, cAvg: relevantAvg.avg})

            } else {
                stateRows.push({name: student.displayName, hwk: task.title, test: '-', subject: relevantAvg.subject, lateHwk: lateHwk, lateTests: lateTests, score: task.data.Score, cAvg: relevantAvg.avg})
            }
        })

        console.log('TO STATE?', stateRows)
        this.setState({
            ...this.state,
            rowRawData: stateRows
        })
        
    }

    matchAvg = (title, arr) => { 
        var output 
        arr.forEach( avg => { 
            if (avg.title == title){
                return output = avg
            }
        })
        return output
    }

    getStatus = (arr1, arr2) => {
        var status
        if (arr1.length > 0 && arr2.length > 0) {
             status = 1
        }
        if (arr1.length == 0 && arr2.length > 0) {
             status = 2
        }
        if (arr1.length > 0 && arr2.length == 0) {
             status = 3
        }
        if (arr1.length == 0 && arr2.length == 0){
             status = 0
        }
        return status
    }

    getAvgScore = arr => {
        var count = arr.length;
        var rT = 0;
        var output = []
        arr.forEach( attempt => { 
            output.push(attempt.data.Score)
        })
        
        
        // console.log('AVG SCORE', output) //debug
        return output
    }

    getGroupAvg = (arr, list) => { 
        console.log('GGA', arr, list)
        var relevant = [];
        var avgs = [];

        arr.forEach( task => {
            list.forEach( lT => { 
                if (task.title == lT.title){
                    relevant.push(task)
                }
            })
        })

        relevant.forEach( task => { 
            var count = 0;
            var rT = 0;
            task.data.AssignedTo.forEach( student => { 
                if (student.CompletionDate != 'N/A'){
                    count = count + 1;
                    rT = rT + student.Score
                }
            })
            if (rT != 0){
                avgs.push({avg: rT/count, title: task.title, subject: task.data.Subject})
            } else {
                avgs.push({avg: 0, title: task.title, subject: task.data.Subject})
            }
            
        })
        // var output = 0
        // avgs.forEach( avg => { 
        //     output = output + avg
        // })

        // if (output != 0){
        //     output = output/avgs.length
        // } else {
        //     output = 0;
        // }

        return avgs
    }

    makeTableData = () => { 
        return this.rows(this.state.rowRawData)
    }

    rows = arr => {
        var output  = []
        arr.map( obj => { 
            if (obj.subject == this.state.viewSubject){
                output.push(
                    this.createData(obj.name, obj.hwk, obj.test, obj.subject, obj.lateHwk, obj.lateTests, obj.score, obj.cAvg)
                )
            }
        })
        return output
    }

    createData = (name, hwk, test, subject, lateH, lateT, score, cAvg) => { 
        id += 1;
        return {id, name, hwk, test, subject, lateH, lateT, score, cAvg}
    }
    render (){
        const { classes } = this.props
        return (
            this.state.loaded && this.state.levels && this.state.levels.length > 0 ? 

            <div className={classes.root}>
                <Grid container
                    spacing={24}
                    direction='row'
                    justify='space-evenly'
                    alignContent='center'
                >
                    <Grid item xs={4} className={classes.grid}>
                        <Paper className={classes.paper} elevation={1}>
                            <Typography variant='headline'>
                                Specify dataset
                            </Typography>
                            <Divider/>
                            <br/>
                            <TextField
                                id='Level'
                                value={this.state.viewLevel}
                                onChange={this.handleChange('viewLevel')}
                                margin='normal'
                                helperText='Please select a level to view'
                                select
                            >
                                {this.state.levels.map(level => (
                                    <MenuItem key={this.state.levels.indexOf(level)} value={level}>
                                        {level}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <br/>
                            {this.state.viewLevel != '' ?
                                <TextField
                                    id='Subject'
                                    value={this.state.viewSubject}
                                    onChange={this.handleChange('viewSubject')}
                                    margin='normal'
                                    error={this.state.subjects[this.state.levels.indexOf(this.state.viewLevel)] && this.state.subjects[this.state.levels.indexOf(this.state.viewLevel)].length == 0} //error if there arent any subjects in this level
                                    helperText='Please select a subject to view'
                                    select
                                    >
                                    {this.state.subjects[this.state.levels.indexOf(this.state.viewLevel)].map(subject => (
                                        <MenuItem key={this.state.subjects.indexOf(subject)} value={subject}>
                                            {subject}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                                        
                            :
                               <div/>
                            }
                            <br/>
                            {this.state.viewSubject != '' ?
                                <TextField
                                    id='Year'
                                    value={this.state.viewYr}
                                    onChange={this.handleChange('viewYr')}
                                    margin='normal'
                                    helperText='Please select a year to view'
                                    select
                                    >
                                    {this.state.years[this.state.levels.indexOf(this.state.viewLevel)][this.state.subjects[this.state.levels.indexOf(this.state.viewLevel)].indexOf(this.state.viewSubject)].map(year => (
                                        <MenuItem key={this.state.years[this.state.levels.indexOf(this.state.viewLevel)][this.state.subjects[this.state.levels.indexOf(this.state.viewLevel)].indexOf(this.state.viewSubject)].indexOf(year)} value={year}>
                                            {year}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                                        
                            :
                                <div/>
                            }
                            <br/>
                            {this.state.viewYr != '' ? 
                                <TextField
                                    id='Student'
                                    value={this.state.student}
                                    onChange={this.handleChange('student')}
                                    margin='normal'
                                    helperText='Please select a student to view'
                                    select
                                >
                                {this.StudentList(this.state.students).map(student => (
                                    <MenuItem key={this.state.students.indexOf(student)} value={student.UID}>
                                        {student.displayName}
                                    </MenuItem>
                                ))}
                                </TextField>
                            
                            :
                                <div/>
                            }
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                    {this.state.student != '' ?
                        <Paper className={classes.paper2}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                    <TableCell>User</TableCell>
                                    <TableCell>5 Most Recent Completed Tasks</TableCell>
                                    <TableCell>5 Most Recent Completed Tests</TableCell>
                                    <TableCell>Subject</TableCell>
                                    <TableCell>Overdue Homework</TableCell>
                                    <TableCell>Overdue Tests</TableCell>
                                    <TableCell>Score (%)</TableCell>
                                    <TableCell>Class Avg</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.makeTableData(this.state.rawRowsData)
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map(row => {
                                            console.log(row, 'ROW SUPER')
                                        return (
                                            <TableRow 
                                                key={row.id}
                                                hover
                                                tabIndex={-1}
                                            >
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.hwk}</TableCell>
                                            <TableCell>{row.test}</TableCell>
                                            <TableCell>{row.subject}</TableCell>
                                            <TableCell>
                                                {row.lateH.map( H => { 
                                                    console.log('ROW', row)
                                                    return H.title + ', '
                                                })}
                                            </TableCell>
                                            <TableCell>
                                                {row.lateT.map( T => { 
                                                    
                                                    return T.title + ', '
                                                })}
                                            </TableCell>
                                            <TableCell>{row.score}</TableCell>
                                            <TableCell>{row.cAvg}</TableCell>
                                            {/* {Object.keys(row).slice(Object.keys(row).length - this.state.tests.length, Object.keys(row).length + 1).map(cell => {
                                                //  console.log(this.state.cells, this.state.cells[this.state.cells.length - 1])
                                                console.log('CELL', cell)
                                                return <TableCell >{row[cell] + '%'}</TableCell>
                                            })} */}
                                        </TableRow>
                                        )
                                    })}
                                </TableBody>   
                            </Table>
                        </Paper>
                    :
                        <div/>
                    }
                    </Grid>
                </Grid>
            </div>
            :

            <div><CircularProgress/></div>
            
        )
    }
}
export default withStyles(styles)(performance2)


// WEBPACK FOOTER //
// ./src/pages/View/performance2.jsx